import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var KeyboardDoubleArrowDown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
  }));
});
KeyboardDoubleArrowDown.displayName = 'KeyboardDoubleArrowDown';
export var KeyboardDoubleArrowDownDimensions = {
  height: 24,
  width: 24
};